export default __webpack_public_path__ + "static/media/me.67642fce.jpeg";